import { render, staticRenderFns } from "./CampoFechaEmision.vue?vue&type=template&id=028c896e&scoped=true&"
import script from "./CampoFechaEmision.vue?vue&type=script&lang=js&"
export * from "./CampoFechaEmision.vue?vue&type=script&lang=js&"
import style0 from "./CampoFechaEmision.vue?vue&type=style&index=0&id=028c896e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c896e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028c896e')) {
      api.createRecord('028c896e', component.options)
    } else {
      api.reload('028c896e', component.options)
    }
    module.hot.accept("./CampoFechaEmision.vue?vue&type=template&id=028c896e&scoped=true&", function () {
      api.rerender('028c896e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoFechaEmision.vue"
export default component.exports